import { AbstractControl, ValidationErrors } from '@angular/forms';

export function bothDatesRangeNotEmptyValidator(control: AbstractControl): ValidationErrors | null {
  if (control.value) {
    const startDateControl = control.parent.get('startDate');
    const endDateControl = control.parent.get('endDate');
    if ((startDateControl.value && !endDateControl.value) || (!startDateControl.value && endDateControl.value))
      return { oneDateEmptyOtherNot: true };
  }
  return null;
}

export function dateRangeValidator(control: AbstractControl): ValidationErrors | null {
  if (control.value) {
    const startDateControl = control.parent.get('startDate');
    const endDateControl = control.parent.get('endDate');
    if (startDateControl.value && endDateControl.value && startDateControl.value >= endDateControl.value)
      return { incorrectDatesOrder: true };
  }
  return null;
}

export function timeRangeValidator(control: AbstractControl): ValidationErrors | null {
  if (control.parent && control.value) {
    const startTimeControl = control.parent.get('from');
    const endTimeControl = control.parent.get('to');
    if (startTimeControl && endTimeControl && startTimeControl.value && endTimeControl.value && startTimeControl.value >= endTimeControl.value)
      return { incorrectTimesOrder: true };
  }
  return null;
}
